import { useQuery } from '@tanstack/react-query';
import { getAppInstance } from '@/utils/api/app';
import { useSession } from '@zopauk/nextjs-auth';
import type { AxiosResponse, AxiosError } from 'axios';

export const useQueryCreditCards = () => {
  const { data: session } = useSession();

  return useQuery<AxiosResponse<string[]>, AxiosError>({
    queryFn: () => getAppInstance().get('/web-hub/primary-cards'),
    queryKey: ['credit-cards', session?.user.memberId],
    enabled: !!session,
  });
};
